export default [{
    text: 'Свет',
    value: 'hasLight'
}, {
    text: 'Электричество',
    value: 'hasElectricity'
}, {
    text: 'Отопление',
    value: 'hasHeating'
}, {
    text: 'Вода',
    value: 'hasWater'
}, {
    text: 'Система пожаротушения',
    value: 'hasExtinguishingSystem'
}];
